import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../data.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {Observable, catchError} from 'rxjs';
import { FrtRatesBidcycles } from 'src/app/shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class FrtRatesBidcyclesService extends DataService {

  private baseURI = this.apiUri + '/ratesbidcycles/';
  private baseURIHhg = this.apiUri + '/hhg/ratesbidcycles/';
  private observable$: any;
  private _logger: LoggerService;

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  createRatesBidcycles(ratesBidCycles: FrtRatesBidcycles): Observable<any> {
    return this.http.post(this.baseURI + 'create', ratesBidCycles).pipe(catchError(this.handleError));
  }

  updateRatesBidcycles(ratesBidCycles: FrtRatesBidcycles): Observable<any> {
    return this.http.post(this.baseURI + 'update', ratesBidCycles).pipe(catchError(this.handleError));
  }

  getAll(): Observable<any> {
    this.setUri(this.baseURI);
    return this.get();
  }

  createHhgRatesBidcycles(ratesBidCycles: FrtRatesBidcycles): Observable<any> {
    return this.http.post(this.baseURIHhg + 'create', ratesBidCycles).pipe(catchError(this.handleError));
  }

  updateHhgRatesBidcycles(ratesBidCycles: FrtRatesBidcycles): Observable<any> {
    return this.http.post(this.baseURIHhg + 'update', ratesBidCycles).pipe(catchError(this.handleError));
  }

  getHhgAll(): Observable<any> {
    this.setUri(this.baseURIHhg);
    return this.get();
  }



  getExtendRates(businessType): Observable<any> {
    if (businessType === 'HHG') {
      return this.http.get(this.apiUri + `/extendRates/extendHhgRates/`);
    } else if (businessType === 'FRT') {
      return this.http.get(this.apiUri + `/extendRates/extendFrtRates/`);
    }
  }
  updateExtendRates(businessType, payload) {
    if (businessType === 'HHG') {
      return this.http.post(this.apiUri + `/extendRates/extendHhgExpiryDates/`, payload);
    } else if (businessType === 'FRT') {
      return this.http.post(this.apiUri + `/extendRates/extendFrtExpiryDates/`, payload);
    }
  }
  getRatesBidCyclesByBusinessTypes(businessType: string): Observable<FrtRatesBidcycles[]> {
    this.setUri(this.baseURI + businessType + '/businessType');
    return this.get().pipe(catchError(this.handleError));
   }

  sendHhgCarrierEmails(ratesBidCycles: FrtRatesBidcycles) {
    return  this.http.post(this.baseURI + 'hhgemails', ratesBidCycles, {responseType: 'text'}).pipe(catchError(this.handleError));
  }

  sendFrtCarrierEmails(ratesBidCycles: FrtRatesBidcycles) {
    return this.http.post(this.baseURI + 'frtemails', ratesBidCycles, {responseType: 'text'}).pipe(catchError(this.handleError));
  }

  startReleaseToProduction(bidCyclesId, businessType) {
    return this.http.post(this.baseURI + 'productionRelease/' + bidCyclesId + '/ratesBidcyclesId/' + businessType + '/businessType', {}, {responseType: 'text'}).pipe(catchError(this.handleError));
  }
// Release to preprod service
  startReleaseToPreprod(bidCyclesId, businessType) {
    return this.http.post(this.baseURI + 'preprodRelease/' + bidCyclesId + '/ratesBidcyclesId/' + businessType + '/businessType', {}, {responseType: 'text'}).pipe(catchError(this.handleError));
  }

  resetBiddCycles(bidCycleId: number): Observable<any> {
    return this.http.post(this.baseURI + bidCycleId + "/resetfrtbidclycle",null).pipe(catchError(this.handleError));
  }
}
